import UserTypes from '../../enums/UserTypes';
import ARLAguardando from '../../views/lojista/AguardandoAprovacao.vue';
import ARLCompletas from '../../views/lojista/Completas.vue';
import ARLCotacao from '../../views/lojista/Cotacao.vue';
import ARLCotAguardandoPagamento from '../../views/lojista/CotacaoAguardandoPagamento.vue';
import ARLCotAprovada from '../../views/lojista/CotacaoAprovada.vue';
import ARLCotCompleta from '../../views/lojista/CotacaoCompleta.vue';
import ARLCotEnviada from '../../views/lojista/CotacaoEnviada.vue';
import ARLCotFinalizada from '../../views/lojista/CotacaoFinalizada.vue';
import ARLCotGanha from '../../views/lojista/CotacaoGanha.vue';
import ARLCotPerdida from '../../views/lojista/CotacaoPerdida.vue';
import ARLCotRecebida from '../../views/lojista/CotacaoRecebida.vue';
import ARLCotRejeitada from '../../views/lojista/CotacaoRejeitada.vue';
import ARLCotRejeitadaCli from '../../views/lojista/CotacaoRejeitadaCli.vue';
import ARLCotResposta from '../../views/lojista/CotacaoResposta.vue';
import ARLIugu from '../../views/lojista/DashboardIugu.vue';
import ARLEnviadas from '../../views/lojista/Enviadas.vue';
import ARLGanhas from '../../views/lojista/Ganhas.vue';
import ARLojista from '../../views/lojista/Index.vue';
import ARLMeusDados from '../../views/lojista/MeusDados.vue';
import ARLPerdidas from '../../views/lojista/Perdidas.vue';
import ARLRecebidas from '../../views/lojista/Recebidas.vue';
import ARLRejeitadasPC from '../../views/lojista/RejeitadasPC.vue';
import ARLRejeitadasPU from '../../views/lojista/RejeitadasPU.vue';
import ARLIuguUpdate from '../../views/lojista/UpdateIugu.vue';
import ARLIuguAssinatura from '../../views/lojista/ARLIuguAssinatura.vue';
import ARLIuguValidation from '../../views/lojista/ValidationIugu.vue';
import ARLSolicitarApp from '../../views/lojista/SolicitarApp.vue';
import CustomizationSocialMedia from '../../views/lojista/customizations/SocialMedias.vue';
import ListDestaque from '../../views/lojista/customizations/List.vue';
import CustomizationLinkTree from '../../views/lojista/customizations/LinkTree.vue';
import ArtesSocialMedia from '../../views/lojista/artesRedesSociais/Index.vue';
import AssinaturaAppSite from '../../views/lojista/AssinaturaAppSite.vue';
import CartaoCredito from '../../views/lojista/CartaoCredito.vue';
import CartaoCreditoAppAss from '../../views/lojista/CartaoCreditoAppAss.vue';
import AssinaturaCartaoCreditoApp from '../../views/lojista/AssinaturaCartaoCreditoApp.vue';
import CustomizationAbout from '../../views/lojista/customizations/About.vue';
import CustomizationHour from '../../views/lojista/customizations/OpeningHours.vue';
import LojistaMinhasRegras from '../../views/lojista/regras/Index.vue';
import LojistaMeusPremios from '../../views/lojista/regras/MeusPremios.vue';
import LojistaPremiosSolicitados from '../../views/lojista/regras/PremiosSolicitados.vue';
import RaffleCampaignIndex from '../../views/lojista/raffleCampaign/Index.vue';
import NewMenuHome from '../../views/lojista/customizations/NewMenuHome.vue';
import SelectProducts from '../../views/lojista/products/SelectProducts.vue';
import PartnersProducts from '../../views/lojista/products/PartnersProducts.vue';
import PartnersRegistred from '../../views/lojista/PartnersRegistred.vue';
import CostPriceProducts from '../../views/lojista/products/CostPriceProducts.vue';
import SelectedProducts from '../../views/lojista/products/SelectedProducts.vue';
import ClientList from '../../views/lojista/clients/List.vue';
import DashboardHome from '../../views/lojista/dashboard/Home.vue';
import VerMeuApp from '../../views/lojista/VerMeuApp.vue';
import ChangeColor from '../../views/lojista/customizations/ChangeColor/Index.vue';
import SaveBanner from '../../views/lojista/customizations/Banner/Save.vue';
import ListBanner from '../../views/lojista/customizations/Banner/List.vue';
import ListFlyers from '../../views/lojista/flyers/List.vue';
import OrdersAppList from '../../views/lojista/orders-app/List.vue';
import CartAbandonedAppList from '../../views/lojista/orders-app/CarrinhoAbondonado.vue';
import OrcamentoRealizado from '../../views/balconista/OrcamentoRealizadoAll.vue';
import OrcamentoWhatsapp from '../../views/lojista/OrcamentoWhatsapp.vue';
import FreightSave from '../../views/lojista/freight/Save.vue';
import SuggestProduct from '../../views/lojista/products/SuggestProduct.vue';
import ProdutosAprovacaoLojista from '../../views/lojista/products/ProdutosAprovacaoLojista.vue';
import InsertProduct from '../../views/lojista/products/InsertProduct.vue';
import WaitingProduct from '../../views/lojista/products/WaitingProduct.vue';
import ProductSearch from '../../views/lojista/products/ProductSearch.vue';
import ProductBoost from '../../views/lojista/products/ProductBoost.vue';
import ProductsBestSellers from '../../views/lojista/products/ProductsBestSellers.vue';
import ShopkeeperEditCategory from '../../views/lojista/products/ShopkeeperEditCategory.vue';
import ShopkeeperVariationProduct from '../../views/lojista/products/ShopkeeperVariationProduct.vue';
import IntegrarApiProduct from '../../views/lojista/products/IntegrarApiProduct.vue';
import ReportFacebookAds from '../../views/lojista/report/ReportFacebookAds.vue';
import ReportGoogleAnalytics from '../../views/lojista/report/ReportGoogleAnalytics.vue';
import ReportWhatsAppClicks from '../../views/lojista/report/ReportWhatsAppClicks.vue';
import ReportLinktreeClicks from '../../views/lojista/report/ReportLinktreeClicks.vue';
import AppTipoClientes from '../../views/lojista/products/AppTipoClientes.vue';
import PaymentMethodsSave from '../../views/lojista/payment-methods/Save.vue';
import WalletApp from '../../views/lojista/payment-methods/WalletApp.vue';
import StatisticsDashboard from '../../views/administrador/shopkeeper-app/ordersLojista/List.vue';
import SaveNotification from '../../views/lojista/notifications/Save.vue';
import ListNotification from '../../views/lojista/notifications/List.vue';
import ListNotificationWhatsapp from '../../views/lojista/notifications/WhatsApp.vue';
import ListNotificationNewsletter from '../../views/lojista/notifications/Newsletter.vue';
import ListPromptAgentIA from '../../views/lojista/notifications/ListPromptAgentIa.vue';
import ListPromptAgentIaBelenus from '../../views/lojista/notifications/ListPromptAgentIaBelenus.vue';
import NewErrorBelEnergy from '../../views/lojista/notifications/NewErrorBelEnergy.vue';
import NewProductsBelEnergy from '../../views/lojista/notifications/NewProductsBelEnergy.vue';
import NotificationAppCms from '../../views/lojista/notifications/AppCms.vue';
import ListApprovementRequests from '../../views/lojista/professional/approvement-requests/List.vue';
import ClerkApp from '../../views/lojista/clerk-app/Clerk.vue';
import ProfessionalShopkeeperPanel from '../../views/lojista/ProfessionalShopkeeperPanel.vue';
import CouponDiscount from '../../views/lojista/coupon/CouponDiscount.vue';

export default [
  {
    path: '/area-restrita/lojista',
    name: 'lojista',
    component: ARLojista,
    children: [
      {
        path: '/area-restrita/lojista/meus-dados',
        name: 'lojista-meus-dados',
        component: ARLMeusDados,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/area-profissional',
        name: 'panel-professional',
        component: ProfessionalShopkeeperPanel,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/dashboard/iugu',
        name: 'lojista-iugu-dash',
        component: ARLIugu,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/dashboard/iugu/validation',
        name: 'lojista-iugu-validation',
        component: ARLIuguValidation,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/dashboard/iugu/update',
        name: 'lojista-iugu-update',
        component: ARLIuguUpdate,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/dashboard/assinatura',
        name: 'lojista-iugu-assinatura',
        component: ARLIuguAssinatura,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/solicitar/app',
        name: 'lojista-solicitar-app',
        component: ARLSolicitarApp,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/recebidas/',
        name: 'lojista-recebidas',
        component: ARLRecebidas,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/enviadas/',
        name: 'lojista-enviadas',
        component: ARLEnviadas,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/aguardando-aprovacao/',
        name: 'aguardando-aprovacao',
        component: ARLAguardando,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/ganhas/',
        name: 'lojista-ganhas',
        component: ARLGanhas,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/completas/',
        name: 'lojista-completas',
        component: ARLCompletas,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/rejeitadas-por-usuario/',
        name: 'lojista-rejeitadas-pelo-usuario',
        component: ARLRejeitadasPU,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/rejeitadas-por-cliente/',
        name: 'lojista-rejeitadas-pelos-clientes',
        component: ARLRejeitadasPC,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/perdidas/',
        name: 'lojista-perdidas',
        component: ARLPerdidas,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/cotacao/:id',
        name: 'lojista-cotacao',
        props: true,
        component: ARLCotacao,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/cotacao/resposta/:id',
        name: 'lojista-cotacao-resposta',
        props: true,
        component: ARLCotResposta,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/cotacao/aprovada/:id',
        name: 'lojista-cotacao-aprovada',
        props: true,
        component: ARLCotAprovada,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/cotacao/finalizada/:id',
        name: 'lojista-cotacao-finalizada',
        props: true,
        component: ARLCotFinalizada,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/cotacao/recebida/:id',
        name: 'lojista-cotacao-recebida',
        props: true,
        component: ARLCotRecebida,
        meta: { userType: UserTypes.ADMINISTRATOR.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/cotacao/enviada/:id',
        name: 'lojista-cotacao-enviada',
        props: true,
        component: ARLCotEnviada,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/cotacao/ganha/:id',
        name: 'lojista-cotacao-ganha',
        props: true,
        component: ARLCotGanha,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/cotacao/aguardando-pagamento/:id',
        name: 'lojista-cotacao-aguardando-pagamento',
        props: true,
        component: ARLCotAguardandoPagamento,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/cotacao/completa/:id',
        name: 'lojista-cotacao-completa',
        props: true,
        component: ARLCotCompleta,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/cotacao/rejeitada/:cot_id/:usu_id/:tipo',
        name: 'lojista-cotacao-rejeitada',
        props: true,
        component: ARLCotRejeitada,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/cotacao/rejeitada/cli/:cot_id/:usu_id/:tipo',
        name: 'lojista-cotacao-rejeitada-cli',
        props: true,
        component: ARLCotRejeitadaCli,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/cotacao/perdida/:cot_id/:usu_id',
        name: 'lojista-cotacao-perdida',
        props: true,
        component: ARLCotPerdida,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/customizacoes/redes-sociais',
        name: 'lojista-customizacoes-redes-sociais',
        props: true,
        component: CustomizationSocialMedia,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/customizacoes/destaques',
        name: 'lojista-customizacoes-destaques',
        props: true,
        component: ListDestaque,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/customizacoes/linktree',
        name: 'lojista-customizacoes-linktree',
        props: true,
        component: CustomizationLinkTree,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/artes-redes-sociais',
        name: 'lojista-artes-redes-sociais',
        props: true,
        component: ArtesSocialMedia,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/assinatura-app-site',
        name: 'lojista-assinatura-app-site',
        props: true,
        component: AssinaturaAppSite,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/cartao-de-credito/:id',
        name: 'lojista-cartão-credito',
        props: true,
        component: CartaoCredito,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/cartao-de-credito-app',
        name: 'lojista-cartão-credito-app-ass',
        props: true,
        component: CartaoCreditoAppAss,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/assinatura/cartao-de-credito-app/:type',
        name: 'assinatura-cartão-credito-app',
        props: true,
        component: AssinaturaCartaoCreditoApp,
      },
      {
        path: '/area-restrita/lojista/minhas-regras',
        name: 'lojista-minhas-regras',
        props: true,
        component: LojistaMinhasRegras,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/meus-premios',
        name: 'lojista-meus-premios',
        props: true,
        component: LojistaMeusPremios,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/premios-solicitados',
        name: 'lojista-premios-solicitados',
        props: true,
        component: LojistaPremiosSolicitados,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/campanha-sorteio',
        name: 'lojista-campanha-sorteio',
        props: true,
        component: RaffleCampaignIndex,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/customizacoes/sobre-empresa',
        name: 'lojista-customizacoes-sobre-empresa',
        props: true,
        component: CustomizationAbout,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/customizacoes/horario-funcionamento',
        name: 'lojista-customizacoes-horario-funcionamento',
        props: true,
        component: CustomizationHour,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/produtos/selecao',
        name: 'lojista-produtos-selecao',
        props: true,
        component: SelectProducts,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/partners/wallet-partners',
        name: 'lojista-carteira-parceiros',
        props: true,
        component: PartnersProducts,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/partners/partners-registreds',
        name: 'lojista-parceiros-cadastrados',
        props: true,
        component: PartnersRegistred,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/partners/partners-products',
        name: 'lojista-custo-produtos',
        props: true,
        component: CostPriceProducts,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/produtos/selecionados',
        name: 'lojista-produtos-selecionados',
        props: true,
        component: SelectedProducts,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/produtos/suggest',
        name: 'lojista-produtos-suggest',
        props: true,
        component: SuggestProduct,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/produtos-inserir',
        name: 'lojista-produtos-insert',
        props: true,
        component: InsertProduct,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/produtos-inserir-status',
        name: 'lojista-produtos-status',
        props: true,
        component: ProdutosAprovacaoLojista,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/produtos/wainting',
        name: 'lojista-wainting-product',
        props: true,
        component: WaitingProduct,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/produtos-buscados',
        name: 'lojista-product-search',
        props: true,
        component: ProductSearch,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/produtos-impusionar',
        name: 'lojista-product-boost',
        props: true,
        component: ProductBoost,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/produtos-mais-comprados',
        name: 'lojista-best-sellers',
        props: true,
        component: ProductsBestSellers,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/editar-categoria',
        name: 'lojista-edit-category',
        props: true,
        component: ShopkeeperEditCategory,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/variacao-produto',
        name: 'lojista-variation-product',
        props: true,
        component: ShopkeeperVariationProduct,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/produtos/integrar-api',
        name: 'lojista-integrar-api-product',
        props: true,
        component: IntegrarApiProduct,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/relatorio/facebook-ads',
        name: 'lojista-report-facebook-ads',
        props: true,
        component: ReportFacebookAds,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/relatorio/google-analytics',
        name: 'lojista-report-google-analytics',
        props: true,
        component: ReportGoogleAnalytics,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/relatorio/whatsapp-clicks',
        name: 'lojista-report-whatsapp-clicks',
        props: true,
        component: ReportWhatsAppClicks,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/relatorio/linktree-clicks',
        name: 'lojista-report-linktree-clicks',
        props: true,
        component: ReportLinktreeClicks,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/tipo-clientes',
        name: 'lojista-app-tipo-clientes',
        props: true,
        component: AppTipoClientes,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/clientes',
        name: 'lojista-clientes',
        props: true,
        component: ClientList,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/home',
        name: 'lojista-home',
        props: true,
        component: DashboardHome,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/ver-app',
        name: 'lojista-ver-app',
        props: true,
        component: VerMeuApp,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/customizacoes/mudar-cor',
        name: 'lojista-customizacoes-mudar-cor',
        props: true,
        component: ChangeColor,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/customizacoes/criar-categoria',
        name: 'lojista-customizacoes-criar-categoria',
        props: true,
        component: NewMenuHome,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/customizacoes/banners',
        name: 'lojista-customizacoes-banners',
        props: true,
        component: ListBanner,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/customizacoes/flyers',
        name: 'lojista-customizacoes-flyers',
        props: true,
        component: ListFlyers,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/customizacoes/banner/:id?',
        name: 'lojista-customizacoes-salvar-banner',
        props: true,
        component: SaveBanner,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/pedidos-app',
        name: 'lojista-pedidos-app',
        props: true,
        component: OrdersAppList,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/carrinho-abandonado',
        name: 'carrinho-abondonado',
        props: true,
        component: CartAbandonedAppList,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/orcamento-realizado',
        name: 'orcamento-realizado',
        props: true,
        component: OrcamentoRealizado,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/orcamento-whatsapp',
        name: 'orcamento-whatsapp',
        props: true,
        component: OrcamentoWhatsapp,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/balconista',
        name: 'balconista-app',
        props: true,
        component: ClerkApp,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/frete-app',
        name: 'lojista-frete-app',
        props: true,
        component: FreightSave,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/app/meios-de-pagamento',
        name: 'lojista-app-meios-pagamentos',
        props: true,
        component: PaymentMethodsSave,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/app/cupom-de-desconto',
        name: 'lojista-app-cupom-desconto',
        props: true,
        component: CouponDiscount,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/app/cupom-de-cashback',
        name: 'lojista-app-cupom-cashback',
        props: true,
        component: CouponDiscount,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/app/carteira',
        name: 'lojista-app-carteira',
        props: true,
        component: WalletApp,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/app/estatisticas',
        name: 'lojista-app-estatisticas',
        props: true,
        component: StatisticsDashboard,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/app/notificacoes',
        name: 'lojista-app-notificacoes',
        props: true,
        component: ListNotification,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/app/notificacoes-whatsapp',
        name: 'lojista-app-notificacoes-whatsapp',
        props: true,
        component: ListNotificationWhatsapp,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/app/newsletter-app-notificacoes',
        name: 'newsletter-app-notificacoes',
        props: true,
        component: ListNotificationNewsletter,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/app/agente-ia',
        name: 'lojista-app-agente-ia',
        props: true,
        component: ListPromptAgentIA,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/app/agente-ia-belenergy',
        name: 'lojista-app-agente-ia-belenergy',
        props: true,
        component: ListPromptAgentIaBelenus,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/app/erros-garantia-belenergy',
        name: 'lojista-app-agente-ia-error-belenergy',
        props: true,
        component: NewErrorBelEnergy,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/app/products-belenergy',
        name: 'lojista-app-agente-ia-products-belenergy',
        props: true,
        component: NewProductsBelEnergy,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/app/notificacoes-cms',
        name: 'lojista-app-notificacoes-cms',
        props: true,
        component: NotificationAppCms,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/pixel-facebook',
        name: 'lojista-pixel-facebook',
        props: true,
        component: () =>
          import('@/views/lojista/customizations/PixelFacebook.vue'),
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/ferramentas-analise',
        name: 'lojista-ferramentas-analise',
        props: true,
        component: () =>
          import('@/views/lojista/customizations/AnalyticsTools.vue'),
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/app/notificacoes/:id?',
        name: 'lojista-app-salvar-notificacao',
        props: true,
        component: SaveNotification,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/app/profissionais/solicitacoes',
        name: 'lojista-app-profissionais-solicitacoes',
        props: true,
        component: ListApprovementRequests,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/app/promocoes-digitais',
        name: 'lojista-app-promocoes-digitais',
        props: true,
        component: () =>
          import('@/views/lojista/digital-promotions/SaveDigitalPromotion.vue'),
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/app/webhooks',
        name: 'lojista-app-webhooks',
        props: true,
        component: () => import('@/views/lojista/webhooks/List.vue'),
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/app/webhooks/integracao/:id?',
        name: 'lojista-app-webhooks-integracao',
        props: true,
        component: () => import('@/views/lojista/webhooks/Save.vue'),
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/app/termos-condicoes',
        name: 'lojista-termos-condicoes',
        props: true,
        component: () => import('@/views/lojista/customizations/Terms.vue'),
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/app/politica-devolucao',
        name: 'lojista-politica-devolucao',
        props: true,
        component: () =>
          import('@/views/lojista/customizations/ReturnPolicy.vue'),
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/google-shopping',
        name: 'lojista-google-shopping',
        props: true,
        component: () => import('@/views/lojista/google-shopping/Index.vue'),
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/tiny',
        name: 'lojista-app-tiny',
        props: true,
        component: () => import('@/views/lojista/tiny/Index.vue'),
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/marketplaces',
        name: 'lojista-app-marketplaces',
        props: true,
        component: () => import('@/views/lojista/marketplaces/Index.vue'),
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/marketplaces/integrar-produtos',
        name: 'lojista-app-marketplaces-integrar-produtos',
        props: true,
        component: () =>
          import('@/views/lojista/marketplaces/IntegrateProducts.vue'),
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/marketplaces/produtos-integrados',
        name: 'lojista-app-marketplaces-produtos-integrados',
        props: true,
        component: () =>
          import('@/views/lojista/marketplaces/ProductsIntegrate.vue'),
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/marketplaces/acompanhar-integracao',
        name: 'lojista-app-marketplaces-acompanhar-integracao',
        props: true,
        component: () =>
          import('@/views/lojista/marketplaces/ListProductIntegrations.vue'),
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/app/privacidade',
        name: 'lojista-privacidade',
        props: true,
        component: () => import('@/views/lojista/customizations/Privacy.vue'),
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/erp',
        name: 'lojista-app-erp',
        props: true,
        component: () => import('@/views/lojista/erp/Index.vue'),
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/erp/integrar-produtos',
        name: 'lojista-app-erp-integrar-produtos',
        props: true,
        component: () => import('@/views/lojista/erp/IntegrateProducts.vue'),
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/erp/acompanhar-integracao',
        name: 'lojista-app-erp-acompanhar-integracao',
        props: true,
        component: () =>
          import('@/views/lojista/erp/ListProductIntegrations.vue'),
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/services',
        name: 'lojista-service-insert',
        component: () => import('@/views/lojista/services/ListServices.vue'),
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/anti-fraud',
        name: 'lojista-app-anti-fraud',
        props: true,
        component: () => import('@/views/lojista/anti-fraud/Index.vue'),
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/lojista/anti-fraud/pedidos',
        name: 'lojista-app-anti-fraud-pedidos',
        props: true,
        component: () => import('@/views/lojista/anti-fraud/OrdersList.vue'),
        meta: { userType: UserTypes.SHOPKEEPER },
      },
    ],
  },
];
